// 浏览器标题计算（纯函数，供 router/index.js 守卫调用）
// 移动端 H5：所有页面统一品牌标题「系统名-移动端工作台」（用户定案，2026-08-27）；
// PC 端：沿用「页面名 - 系统名」动态标题
export const MOBILE_TITLE_SUFFIX = '移动端工作台'

export const resolvePageTitle = (mobile, metaTitle, sysName) => {
	if (mobile) {
		return `${sysName}-${MOBILE_TITLE_SUFFIX}`
	}
	return metaTitle ? `${metaTitle} - ${sysName}` : `${sysName}`
}
